/*
 * @Date: 2022-09-23 11:27:31
 * @LastEditTime: 2022-12-30 17:49:08
 * @Description:
 */
const TokenKey = 'yxagent-Admin-Tokens'
const TypeKey = 'yxagent-Admin-Type'
const username = 'yxagent-Admin-Name'
const Authority = 'yxagent-Admin-Authority'
const Sid = 'yxagent-Admin-Sid'
const AccountIdKey = 'yxagent-Admin-Account-Id'
/** 员工类型 key */
const WorkerTypeKey = '_yixiang_agent_worker_type'

export function setToken(data) {
  return localStorage.setItem(TokenKey, data)
}
export function getToken() {
  return localStorage.getItem(TokenKey)
}
export function removeToken() {
  localStorage.setItem('_yixiang_agent_name', '')
  return localStorage.removeItem(TokenKey)
}

export function setType(data) {
  return localStorage.setItem(TypeKey, data)
}

export function setSid(data) {
  return localStorage.setItem(Sid, data)
}

export function getSid() {
  return localStorage.getItem(Sid)
}

export function getType() {
  return localStorage.getItem(TypeKey)
}
export function removeType() {
  return localStorage.removeItem(TypeKey)
}

export function setName(data) {
  return localStorage.setItem(username, data)
}
export function getName() {
  return localStorage.getItem(username)
}
export function removeName() {
  return localStorage.removeItem(username)
}

export function setAuthority(data) {
  return localStorage.setItem(Authority, data)
}
export function getAuthority() {
  return localStorage.getItem(Authority)
}
export function removeAuthority() {
  return localStorage.removeItem(Authority)
}

export function setAccountId(data) {
  return localStorage.setItem(AccountIdKey, data)
}

export function getAccountId() {
  return localStorage.getItem(AccountIdKey)
}

export function removeAccountId() {
  return localStorage.removeItem(AccountIdKey)
}

/**
 * @description 设置员工类型
 * @param {string} data
 */
export function setWorkerType(data) {
  localStorage.setItem(WorkerTypeKey, data)
}

/**
 * @description 获取员工类型
 * @returns {'0' | '1'} 员工类型 = '0' => 代理商, '1' => 员工
 */
export function getWorkerType() {
  return localStorage.getItem(WorkerTypeKey)
}

/**
 * @description 移除员工类型
 */
export function removeWorkerType() {
  localStorage.removeItem(WorkerTypeKey)
}

export function get_father_info() {
  let host = location.host
  if (host == 'http://192.168.101.11:8003/') {
    host = 'zhyx.eingdong.com'
  }
  return {
    title: '易象',
    site: 'https://' + host,
    qrcode_site: 'https://zhyx.eingdong.com/qrcode/api.php?url=',
    qrcode_img: 'https://zhyx.eingdong.com/console/images/qrcode.jpg',
    qrcode_product: 'https://zhyx.eingdong.com/console/images/qrcode1.png',
    logo_w: 'https://zhyx.eingdong.com/console/images/logo_w.png'
  }
}
